import React, { useState, useEffect } from "react";
import styles from "./NavbarDesktop.module.css";
import { getCategoryTree } from "../../lib/getCategoryTree";
import CategoryTree from "./components/CategoryTree/CategoryTree";
import OtherLinks from "./components/OtherLinks/OtherLinks";

const NavbarDesktop = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null); // Update type to accept string or null

  useEffect(() => {
    const fetchCategoryTree = async () => {
      try {
        const data = await getCategoryTree();
        setCategories(data);
        setLoading(false);
      } catch (err) {
        setError("Error fetching category tree");
        setLoading(false);
      }
    };

    fetchCategoryTree();
  }, []);

  return (
    <div className={styles.navbar}>
      <div className={styles.navbarContent}>
        <div className={styles.categoryTreeContainer}>
          <CategoryTree
            categories={categories}
            loading={loading}
            error={error}
          />
        </div>

        {/* Add separator here */}
        <div className={styles.separator}></div>

        <OtherLinks />

        {/* Move the Blog link inside navbarContent */}
        <div className={styles.blogLinkContainer}>
          <a
            href="/blog"
            title="Visita nuestro Blog"
            className={styles.blogLink}
          >
            Blog
          </a>
        </div>
      </div>
    </div>
  );
};

export default NavbarDesktop;
